export enum GroupFilterOption {
	EVERYTHING = 'everything',
	GROUP = 'groupName',
	DESCRIPTION = 'description',
	TYPE = 'type',
	MEMBERS = 'members'
}